import { render } from "./NodeInfoPage.vue?vue&type=template&id=71b47aae"
import script from "./NodeInfoPage.vue?vue&type=script&lang=js"
export * from "./NodeInfoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__